import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  makeStyles,
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';
import cx from 'classnames';
import Loader from '~/src/components/Loader';

const useStyles = makeStyles(({ spacing }) => ({
  title: {
    fontWeight: 700,
  },
  modal: {
    '& .MuiDialog-paper': {
      width: spacing(100),
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      padding: `${spacing(4)}px ${spacing(6)}px ${spacing(8)}px`,
      '& .MuiButton-root': {
        minWidth: spacing(20),
      },
    },
  },
}));

const CopyingDialog = ({ className, open, onPrimaryClick }) => {
  const { t } = useTranslation('projects');
  const { title, modal } = useStyles();

  const handleCloseDialog = (e, reason: string) => {
    // eslint-disable-next-line no-useless-return
    if (reason === 'backdropClick') return;
  };

  return (
    <Dialog open={open} className={cx(modal, className)} onClose={handleCloseDialog}>
      <DialogTitle disableTypography>
        <Box display="flex" justifyContent="center" alignItems="center" height={200}>
          <Loader size={128} />
        </Box>
        <Typography variant="h5" className={title}>
          {t('copyProject.dialog.title')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography color="textSecondary">{t('copyProject.dialog.content')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onPrimaryClick} color="primary">
          {t('copyProject.dialog.goToProjectsButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CopyingDialog.propTypes = {
  open: PropTypes.bool,
  onPrimaryClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

CopyingDialog.defaultProps = {
  open: false,
  className: '',
};

export default CopyingDialog;
